module.exports = __webpack_public_path__ + "static/media/ic_pay_dinersclub.899c6b22.svg";